<template>
  <div id="system_site">
    <el-row :gutter="20">
      <el-col :span="this.$store.state.elColNum">
        <el-form ref="form" :model="form" :label-width="this.$store.state.setLabelWidth" size="small">
          <el-form-item label="网站名称">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item label="网站类型">
            <el-select v-model="form.web_type" placeholder="请选择"
                       :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':''">
              <el-option label="小说" value="1"></el-option>
              <el-option label="直播" value="2"></el-option>
              <el-option label="一对一交友" value="3"></el-option>
              <el-option label="在线教育" value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备案ICP">
            <el-input v-model="form.web_icp"></el-input>
          </el-form-item>
          <el-form-item label="官方QQ">
            <el-input v-model="form.qq"></el-input>
          </el-form-item>
          <el-form-item label="官方微信">
            <el-input v-model="form.weixin"></el-input>
          </el-form-item>
          <el-form-item label="官方手机号">
            <el-input v-model="form.mobile"></el-input>
          </el-form-item>
          <el-form-item label="H5域名">
            <el-input v-model="form.h5_domain"></el-input>
          </el-form-item>
          <el-form-item :label="'注册用户赠送'+this.$store.state.name">
            <el-input v-model="form.givegold"></el-input>
          </el-form-item>
          <el-form-item label="虚拟币名称">
            <el-input v-model="form.coin_name"></el-input>
          </el-form-item>
          <el-form-item label="统一收费章节">
            <el-input v-model="form.unified_anime_paychapter"></el-input>
          </el-form-item>
          <el-form-item :label="'统一章节收费'+this.$store.state.name+''">
            <el-input v-model="form.unified_anime_coin"></el-input>
          </el-form-item>
          <el-form-item label="Android版本code">
            <el-input v-model="form.android_version_code"></el-input>
          </el-form-item>
          <el-form-item label="Android版本名称">
            <el-input v-model="form.android_version"></el-input>
          </el-form-item>
          <el-form-item label="Android强制更新">
            <el-select v-model="form.android_version_must" placeholder="请选择"
                       :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':''">
              <el-option label="是" value="1"></el-option>
              <el-option label="否" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="版本说明">
            <el-select
                v-model="form.android_version_desc"
                multiple
                filterable
                allow-create
                default-first-option
                style="width: 100%">
            </el-select>
          </el-form-item>
          <el-form-item label="Android下载页面">
            <el-input v-model="form.android_download_page"></el-input>
          </el-form-item>
          <el-form-item label="Android下载地址">
            <el-input v-model="form.android_download_url"></el-input>
          </el-form-item>
          <el-form-item label="iOS下载地址">
            <el-input v-model="form.ios_download_url"></el-input>
          </el-form-item>
          <el-form-item label="用户提现次数超限提示">
            <el-input v-model="form.withdraw_overtimes_tip"></el-input>
          </el-form-item>
          <el-form-item label="用户提现资质不足提示">
            <el-input v-model="form.withdraw_lackqualification_tip"></el-input>
          </el-form-item>
          <el-form-item :label="'用户提现'+this.$store.state.name+'不足提示'">
            <el-input v-model="form.withdraw_lackcoin_tip"></el-input>
          </el-form-item>
          <el-form-item label="书架排版">
            <el-select v-model="form.shelve_style" placeholder="请选择书架排版"
                       :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':''">
              <el-option label="横向排版" value="0"></el-option>
              <el-option label="纵向排版" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="跨域域名">
            <el-select
                v-model="form.across_domain"
                multiple
                filterable
                allow-create
                default-first-option
                style="width: 100%">
            </el-select>
          </el-form-item>
          <el-form-item label="是否发布">
            <el-select v-model="form.is_rel" placeholder="请选择"
                       :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':''">
              <el-option label="是" value="1"></el-option>
              <el-option label="否" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">保存</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import quillConfig from '../../utils/quill-config.js'
import {uploadimg} from '../../utils/common'

export default {
  name: "system_site",
  data() {
    return {
      form: {
        name: '',
        qq: '',
        weixin: '',
        mobile: '',
        givegold: '',
        is_rel: '',
        coin_name: '',
        across_domain: '',
        web_type: '',
        web_icp: '',
        unified_anime_paychapter: '',
        unified_anime_coin: '',
        android_version_code: '',
        android_version: '',
        android_version_must: '',
        android_version_desc: '',
        android_download_page:'',
        android_download_url: '',
        ios_download_url: '',
        withdraw_overtimes_tip: '',
        withdraw_lackqualification_tip: '',
        withdraw_lackcoin_tip: '',
        shelve_style:'',
        h5_domain:'',
      },
      headers: {'access-token': sessionStorage.getItem("token")},
      editorOption: quillConfig,
      editorHtml: '',
      options: [{
        value: '1',
        label: '1'
      }, {
        value: '3',
        label: '3'
      }, {
        value: '5',
        label: '5'
      }],
    }
  },
  created() {
    this.getData()
  },
  methods: {
    onSubmit() {
      this.$axios.post('admin/config/site_set', {config: this.form}).then((res) => {
        this.$message.success('成功');
        this.getData()
      });
    },
    getData() {
      this.$axios.post('admin/config/site', '').then((res) => {
        this.form = res.data;
        this.form.redesc = this.html_decode(this.form.redesc);
        this.form.invitedesc = this.html_decode(this.form.invitedesc);
        this.form.wdesc = this.html_decode(this.form.wdesc);
        this.$store.dispatch('getNewName', this.form.name)
      });
    },
    myUpload(content) {
      uploadimg(content).then(res => {
        this.form.sharepic = res;
      })
    },
    beforeAvatarUpload(file) {
      var suffix = file.name.substring(file.name.lastIndexOf('.') + 1);
      let arr = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'pdf', 'JPG', 'JPEG', 'PNG', 'GIF', 'BMP', 'PDF']
      if (arr.indexOf(suffix) === -1) {
        this.$message.error('上传图片格式有误');
        return false
      }
    },
    html_decode(str) {
      var s = "";
      if (str.length == 0) return "";
      s = str.replace(/&amp;/g, "&");
      s = s.replace(/&lt;/g, "<");
      s = s.replace(/&gt;/g, ">");
      s = s.replace(/&nbsp;/g, " ");
      s = s.replace(/&#39;/g, "\'");
      s = s.replace(/&quot;/g, "\"");
      s = s.replace(/<br\/>/g, "\n");
      return s;
    }

  }
}
</script>

<style scoped lang="scss">

</style>